import Glide from "@glidejs/glide";

if (document.getElementById("js-glide-content")) {
  const config = {
    animationDuration: 1000,
    animationTimingFunc: "ease",
    perView: 1,
    gap: 0,
    type: "carousel",
    autoheight: true
  };
  let glide = new Glide('.glide-content', config)

  if (document.getElementById('index-content')) {
    let index = document.getElementById('index-content')
    glide.on("move", () => index.innerText = glide.index + 1)
  }   

  // const buttonCarousel = document.querySelectorAll(".js-button-content").forEach((e,index) => {
  //   e.addEventListener("click", () => {

      

  //   })
  // })

  glide.mount()
}
